import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from 'react-bootstrap/Modal';
import Form from "react-bootstrap/Form";
import { GetDocuments } from "./GetDocuments";
import { useAptApi } from "../../hooks/UseAptApi";
import { EngagementsLayout } from "./EngagementsLayout";
import Loading from "../misc/Loading";
import { useAsyncError } from "../../hooks/useAsyncError";
import { ApiError } from "../errors/CustomErrors";
import "./Landing.css";
import StatusPage from "components/layout/StatusPage";
import { ErrorModal } from "components/errors/ErrorModal";
// import AsyncTypeahead from "react-bootstrap-typeahead/types/components/AsyncTypeahead/AsyncTypeahead";

export const AptEngagements = () => {
  const [engagements, setEngagements] = useState([]);
  const [item, setItem] = useState({ engagementId: "" });
  const [formSubmit, setformSubmit] = useState(false);
  const { engagementId } = item;
  const { GetEngagements, GetEngagementFolders, CopyDocuments, SearchProjects } = useAptApi();
  const [loading, SetLoading] = useState(false);
  const [loadingFolders, SetLoadingFolders] = useState(false);
  const [showAdvanceScan, SetShowAdvanceScan] = useState(false);
  const [engagementFolders, SetEngagementFolders] = useState([]);
  const [selectedFolders, SetSelectedFolders] = useState([]);
  const [selectedFiles, SetSelectedFiles] = useState([]);
  const [responseData, setResponseData] = useState();
  const [submittingAdvance, setSubmittingAdvance] = useState(false);
  /*
  * Will be added back in 2.4 for project code based scanning
  const [isSearching, setIsSearching] = useState(false);
  const [projects, setProjects] = useState([]);  
  const [selectedProjectCode, setSelectedProjectCode] = useState(null);
  const [selectedProjectName, setSelectedProjectName] = useState(null);
  */
  const abortRef = useRef(null);
  const throwError = useAsyncError();
  const [error, setError] = useState(null);

  
  const handleChange = (e) => {
    e.persist();
    console.log(e.target.value);

    setItem((prevState) => ({
      ...prevState,
      engagementId: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setformSubmit(!formSubmit);
  };

  const onFolderChange = (e) => {
    if(e.target.checked) {
      const docId = e.target.value;
      selectedFolders.push(docId);
      SetSelectedFolders([].concat(selectedFolders));
    } else {
      let temp = selectedFolders.filter(x => {
        return x != e.target.value;
      });
      SetSelectedFolders(temp);
    }
  };

  const onFileChange = (e) => {
    if(e.target.checked) {
      const docId = e.target.value;
      selectedFiles.push(docId);
      SetSelectedFiles(selectedFiles);
    } else {
      let temp = selectedFiles.filter(x => {
        return x != e.target.value;
      });
      SetSelectedFiles(temp);
    }
  };

  const onOkClick = async (evt) => {
    try {
      setSubmittingAdvance(true);
      var allFolders = engagementFolders.filter(x => { return x.documentType == 'Folder'; });
      let isAllFoldersSelected = selectedFolders.length == allFolders.length;
      
      const body = {
        // projectCode: selectedProjectCode,
        // projectName: selectedProjectName,
        selectedFolders: isAllFoldersSelected ? [] : selectedFolders,
        selectedLargeFiles: selectedFiles
      };
      let response = await CopyDocuments(engagementId, body);
            
      if (response.isSuccess) {
        SetShowAdvanceScan(false);
        setResponseData(response.data);
      } else {
        SetShowAdvanceScan(false);
        setError(response.data || 'An error occurred while copying documents');
      }
      setSubmittingAdvance(false);
    } catch (ex) {
      throwError(ex);
    }
};

  const getEngagementFolders = async (e) => {
    e.preventDefault();
    SetShowAdvanceScan(true);
    SetLoadingFolders(true);
    try {
      let response = await GetEngagementFolders(engagementId);      
      if (response.isSuccess) {
        SetEngagementFolders(response.data.documents);
        SetSelectedFolders(response.data.documents.filter(x => x.documentType == 'Folder').map(x => x.documentID));
        SetLoadingFolders(false);
        
      } else {
        throwError(
          new ApiError({
            apiMessage: response.message || response.data.message,
            statusCode: response.statusCode,
          })
        );
      }
    } catch (ex) {
      throwError(ex);
    }
  };

  /*
  * Will be added back in 2.4 for project code based scanning
    // Simple debounce helper
  const debounce = (fn, delay) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  const onSearchProjects = useCallback(async (query) => {
    
// guard: AsyncTypeahead won't call this until minLength is met,
    // but keep a defensive check if you re-use fetch elsewhere.
    if (query && query.length < 3) return;

    // Abort previous request, if any
    if (abortRef.current) abortRef.current.abort();
    abortRef.current = new AbortController();


    setIsSearching(true);
    try {
      let response = await SearchProjects(query);      
      if (response.isSuccess) {
        const options = response.data.value?.map(proj => {
          return {
            id: proj.ProjectCode,
            label: `${proj.ProjectCode} - ${proj.Name}`,
            name: proj.Name
          };
        });
        setProjects(options);
      } else {
        throwError(
          new ApiError({
            apiMessage: response.message || response.data.message,
            statusCode: response.statusCode,
          })
        );
      }
    } catch (ex) {
      setProjects([]);
      throwError(ex);
    } finally {
      setIsSearching(false);
    }
  }, []);

  // Debounce the backend call (250–400ms is typical)
  /*
  const debouncedSearch = useMemo(() => debounce(onSearchProjects, 500), [onSearchProjects])
  */

  useEffect(() => {
    SetLoading(true)
    async function LoadEngagements() {
      try {
        let response = await GetEngagements();

        if (response.isSuccess) {
          setEngagements(response.data.engagements);
          SetLoading(false);
        } else {
          throwError(
            new ApiError({
              apiMessage: response.message || response.data.message,
              statusCode: response.statusCode,
            })
          );
        }
      } catch (ex) {
        throwError(ex);
      }
    }

    LoadEngagements();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {responseData ? <StatusPage
          // @ts-ignore
          status={responseData.response.success}
          // @ts-ignore
          message={responseData.response.message}
        /> :
      (!formSubmit) ? (
        <>
          <EngagementsLayout />
          {!loading ? (
            <form
              onSubmit={handleSubmit}
              className="main form"
              id="engagementId"
            >             
              {engagements.map((engagement) => (
                <div className="item" key={engagement.engagementId}>
                  <Form.Check key={engagement.engagementId}
                    value={engagement.engagementId}
                    type="radio"                    
                    aria-label="radio 1"
                    label={engagement.entityNameStateDate}
                    onChange={handleChange}
                    checked={engagementId === engagement.engagementId}
                  />
                </div>
              ))}
              {engagements.length === 0 && (
                <h3>There are no active engagements assigned to you.</h3>
              )}
              <div className="submitButtonContainer">
                <Button
                  className="bdoSecondaryBtn"
                  //type="submit"
                  onClick={getEngagementFolders}
                  disabled={engagements.length === 0 || !engagementId}
                >
                  Specific File Checks
                </Button>
                <Button
                  className="bdoPrimaryBtn"
                  variant="primary"
                  type="submit"
                  disabled={engagements.length === 0 || !engagementId}
                >
                  Submit
                </Button>
              </div>
            </form>
          ): <Loading text="Loading Engagements" />}
          {showAdvanceScan && 
              <Modal show={showAdvanceScan} onHide={() => {
                SetShowAdvanceScan(false);
              }}>
                
                <Modal.Header closeButton>
                  <Modal.Title>Specific File Checks</Modal.Title>
                </Modal.Header>
        
                <Modal.Body>
                  {loadingFolders ? <Loading text="Loading folders..." /> : 
                  <>
                    <div>
                      Select the specific folders from your APT workspace that you want to scan the documents for, selecting all folders will scan all files regardless of their folder location.
                    </div>
                    <Form.Label style={{fontWeight: 600}}>
                      Select folders to scan:
                    </Form.Label>
                    <div style={{maxHeight: 500, overflowX: 'auto', padding: 6}}>
                      {engagementFolders.filter(x => {
                        return x.documentType == 'Folder';
                      }).map((doc) => (
                          <Form.Check
                            label={doc.orginalDocumentName}
                            name="engagement-folder"
                            type={'checkbox'}
                            value={doc.documentID}
                            id={`inline-${doc.documentID}`}
                            onChange={onFolderChange}
                            defaultChecked={true}
                          />
                      ))}
                      </div>
                      {/* This belongs to 2.4
                      <Form.Label style={{fontWeight: 600}}>
                      Select large file to skip:
                    </Form.Label>
                    <div style={{maxHeight: 500, overflowX: 'auto', padding: 6}}>
                      {engagementFolders.filter(x => {
                        return x.documentType == 'Document';
                      }).map((doc) => (
                          <Form.Check
                            label={doc.orginalDocumentName}
                            name="engagement-file"
                            type={'checkbox'}
                            value={doc.documentID}
                            id={`inline-${doc.documentID}`}
                            onChange={onFileChange}
                            defaultChecked={false}
                          />
                      ))}
                      </div>
                      */}
                    </>
                    }
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => {
                      SetShowAdvanceScan(false);
                    }}>Close</Button>
                  <Button variant="primary" className="bdoPrimaryBtn" onClick={onOkClick} disabled={selectedFolders.length == 0 || submittingAdvance}>OK</Button>
                </Modal.Footer>
            </Modal>
          }
          {error && <ErrorModal title="Max Requests Reached" message={error} show={true} onHide={() =>  {
            window.location.reload();
            setError(null);
          }} />}
        </>
      ) : (
        <GetDocuments engagmentId={engagementId} projectCode={null} projectName={null} />
      )
      }
    </>
  );
};

/** Project code will be added back later
 *  <Form.Group className="mb-3">
                <Form.Label>Select Project Code</Form.Label>
                <AsyncTypeahead
                  isLoading={isSearching}
                  id="searchProject"
                  minLength={3}
                  onSearch={debouncedSearch}
                  options={projects}
                  onChange={(options) => {
                    var option = options[0];
                    console.log(option);
                    if(option) {
                      setSelectedProjectCode(option.id);                      
                      setSelectedProjectName(option.name);
                    } else {
                      setSelectedProjectCode(null);
                      setSelectedProjectName(null);
                    }
                  }}
                  placeholder="Type at least 3 characters to search"                  
                  emptyLabel={
                    isSearching ? 'Searching...' :
                    'No matches found'
                  }
                />
              </Form.Group>
 */